import { authPatch } from "@api";
import { Organization } from "@types";

export const patchOrgName = (
  organizationId: number,
  newName: string
): Promise<Organization> => {
  const path = `/api/agent/organizations/${organizationId}`;
  return authPatch<{ change_name: string }, { organization: Organization }>(
    path,
    { change_name: newName }
  ).then((res) => res.organization);
};
